<template>
  <picture>
    <source
      :srcset="mobileSrc ? mobileSrc : desktopSrc"
      media="(max-width: 576px)"
    />
    <img
      :src="desktopSrc"
      :alt="imageAlt"
      class="responsive-image"
      :class="imageCss"
    />
  </picture>
</template>

<script>
export default {
  props: {
    mobileSrc: {
      type: String,
      required: false,
      default: null
    },
    desktopSrc: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: null
    },
    imageCss: {
      type: String,
      default: null
    }
  }
};
</script>
